// Configuration API
const API_CONFIG = {
  BASE_URL: 'https://mesprix.fr/api'
};

export default API_CONFIG; 